/* ==========================================================================
POSŒNNOÏSME — KATÛVÝS / MODE CHERCHEUR
Asset JS Shopify-safe
- données séparées dans le JSON
- affichage uniquement avec ?mode=chercheur
- fermeture du bloc immédiatement au-dessus
========================================================================== */
(function () {
  'use strict';

  var cfg = window.PO_KATUVYS_RESEARCH_MODE_CONFIG || {};
  var SHELL_ID = cfg.shellId || 'po-katuvys-research-shell';
  var MOUNT_SELECTOR = cfg.mountSelector || '#po-katuvys-research-mount';
  var MODE_PARAM_NAME = cfg.modeParamName || 'mode';
  var MODE_PARAM_VALUE = cfg.modeParamValue || 'chercheur';
  var STORAGE_KEY = cfg.storageKey || 'po_katuvys_research_lang';
  var DEFAULT_LANG = cfg.defaultLang || 'fr';
  var CLOSE_PREVIOUS = cfg.closePrevious !== false;

  var shell, mount, allData, lang = DEFAULT_LANG;

  var CANONICAL_TERMS = [
    'Posœnnoïa','Posœnnoïsme','Posœnnoïal','Posœnnoïamie','Posœnnomia','Posœnnomnèse',
    'Katûvýs','Katûsýs','Katûvýsissence','Katûvýsqun','Katûpirsia','Balakallpa','Àpákan',
    'Lulæṣírasen','Taxiêlîs','Tiqqunbahu','Takimarah','Mathêsis ontologique posœnnoïale',
    'MOPo','Extratinrieur','Ušôprogalenmestûd','Isqun','Threnisqun','RéZonans',
    'Méditations Posœnnoïales','Accords Posœnnoïaux','Organon','Ennéagone'
  ];

  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);} else {fn();} }
  function safeURL(){ try{return new URL(window.location.href);}catch(e){return null;} }
  function isResearchMode(){ var url=safeURL(); return !!(url && url.searchParams.get(MODE_PARAM_NAME)===MODE_PARAM_VALUE); }
  function getSavedLang(){ try{ var raw=localStorage.getItem(STORAGE_KEY); if(/^(fr|en|es)$/.test(raw)) return raw; }catch(e){} return DEFAULT_LANG; }
  function setLang(next){ lang=/^(fr|en|es)$/.test(next)?next:DEFAULT_LANG; try{localStorage.setItem(STORAGE_KEY,lang);}catch(e){} document.documentElement.setAttribute('lang',lang); }

  function escapeHtml(str){
    return String(str == null ? '' : str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }

  function protectCanonicalTerms(input){
    var html = escapeHtml(input == null ? '' : input);
    CANONICAL_TERMS.forEach(function(term){
      var safe = term.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
      html = html.replace(new RegExp(safe,'g'), '<span class="notranslate" translate="no">'+term+'</span>');
    });
    return html;
  }

  function t(obj){ if(!obj) return ''; return obj[lang] || obj.fr || obj.en || obj.es || ''; }
  function paras(arr){ if(!Array.isArray(arr)) return ''; return arr.map(function(p){ return '<p>'+protectCanonicalTerms(p)+'</p>'; }).join(''); }

  function showShell(){ shell.hidden=false; shell.setAttribute('aria-hidden','false'); }
  function hideShell(){ shell.hidden=true; shell.setAttribute('aria-hidden','true'); if(mount) mount.innerHTML=''; }

  function closePreviousBlock(){
    if(!CLOSE_PREVIOUS || !shell) return;
    var prev = shell.previousElementSibling;
    while(prev){
      if(prev.tagName && prev.tagName.toLowerCase()==='details'){ prev.open=false; return; }
      if(prev.hasAttribute && prev.hasAttribute('open')){ prev.removeAttribute('open'); return; }
      if(prev.classList && prev.classList.contains('is-open')){ prev.classList.remove('is-open'); return; }
      if(prev.offsetParent !== null){ prev.setAttribute('hidden','hidden'); prev.setAttribute('aria-hidden','true'); return; }
      prev = prev.previousElementSibling;
    }
  }

  function syncLangButtons(){
    var buttons = shell.querySelectorAll('[data-po-lang]');
    buttons.forEach(function(btn){
      btn.setAttribute('aria-pressed', btn.getAttribute('data-po-lang')===lang ? 'true' : 'false');
    });
  }

  function renderStat(stat){
    return '<div class="po-rm-stat"><div class="po-rm-stat-k">'+escapeHtml(t(stat.k))+'</div><div class="po-rm-stat-v">'+protectCanonicalTerms(t(stat.v))+'</div></div>';
  }

  function renderBlock(block){
    return '<div class="po-rm-block"><div class="po-rm-block-title">'+escapeHtml(t(block.title))+'</div>'+paras(t(block.paragraphs))+'</div>';
  }

  function renderNote(note){
    return '<div class="po-rm-note"><div class="po-rm-note-title">'+escapeHtml(t(note.title))+'</div>'+paras(t(note.paragraphs))+'</div>';
  }

  function renderCard(card){
    if(card.type==='bullets'){
      return '<div class="po-rm-card"><div class="po-rm-card-title">'+escapeHtml(t(card.title))+'</div><ul class="po-rm-bullets">'+
        (card.bullets||[]).map(function(b){ return '<li>'+protectCanonicalTerms(b)+'</li>'; }).join('')+
        '</ul></div>';
    }
    if(card.type==='list'){
      return '<div class="po-rm-card"><div class="po-rm-card-title">'+escapeHtml(t(card.title))+'</div><table class="po-rm-table"><tbody>'+
        (card.rows||[]).map(function(r){ return '<tr><th>'+protectCanonicalTerms(r[0])+'</th><td>'+protectCanonicalTerms(r[1])+'</td></tr>'; }).join('')+
        '</tbody></table></div>';
    }
    return '';
  }

  function renderItem(item, openByDefault){
    return '<details class="po-rm-item"'+(openByDefault?' open':'')+'>'+
      '<summary class="po-rm-summary"><span class="po-rm-summary-left">'+
      '<span class="po-rm-kicker">'+escapeHtml(t(item.kicker))+'</span>'+
      '<span class="po-rm-title">'+protectCanonicalTerms(t(item.title))+'</span>'+
      '<span class="po-rm-kind">'+escapeHtml(t(item.kind))+'</span>'+
      '</span><span class="po-rm-chevron" aria-hidden="true"></span></summary>'+
      '<div class="po-rm-panel"><div class="po-rm-grid"><div class="po-rm-copy">'+paras(t(item.paragraphs))+'</div><div class="po-rm-stats">'+
      ((item.stats||[]).map(renderStat).join(''))+'</div></div>'+
      ((item.blocks&&item.blocks.length)?'<div class="po-rm-blocks">'+item.blocks.map(renderBlock).join('')+'</div>':'')+
      ((item.notes&&item.notes.length)?'<div class="po-rm-notes">'+item.notes.map(renderNote).join('')+'</div>':'')+
      ((item.cards&&item.cards.length)?'<div class="po-rm-cards">'+item.cards.map(renderCard).join('')+'</div>':'')+
      '</div></details>';
  }

  function renderTabButton(tab, active){
    return '<button type="button" class="po-rm-tab'+(active?' is-active':'')+'" data-po-tab="'+escapeHtml(tab.id)+'" aria-selected="'+(active?'true':'false')+'">'+escapeHtml(t(tab.label))+'</button>';
  }

  function renderPanel(tab, active, tabIndex){
    return '<section class="po-rm-tabpanel'+(active?' is-active':'')+'" data-po-panel="'+escapeHtml(tab.id)+'">'+
      '<div class="po-rm-sectionhead"><div class="po-rm-section-kicker">'+escapeHtml(t(tab.kicker))+'</div>'+
      '<h2 class="po-rm-section-title">'+protectCanonicalTerms(t(tab.title))+'</h2>'+
      '<p class="po-rm-section-lede">'+protectCanonicalTerms(t(tab.lede))+'</p></div>'+
      '<div class="po-rm-accordion">'+(tab.items||[]).map(function(item,i){ return renderItem(item, !!item.openByDefault || (tabIndex===0 && i===0)); }).join('')+'</div></section>';
  }

  function renderApp(data){
    var tabs = data.tabs || [];
    return '<section class="po-rm-root"><div class="po-rm-hero"><div class="po-rm-wrap">'+
      '<div class="po-rm-eyebrow">'+escapeHtml(t(data.page.eyebrow))+'</div>'+
      '<h1 class="po-rm-h1">'+protectCanonicalTerms(t(data.page.h1))+'</h1>'+
      '<div class="po-rm-rule" aria-hidden="true"></div>'+
      '<p class="po-rm-lede">'+protectCanonicalTerms(t(data.page.lede))+'</p>'+
      '<div class="po-rm-meta">'+
      '<div class="po-rm-meta-card"><div class="po-rm-meta-k">'+escapeHtml(t(data.page.meta_definition_k))+'</div><div class="po-rm-meta-v">'+protectCanonicalTerms(t(data.page.meta_definition_v))+'</div></div>'+
      '<div class="po-rm-meta-card"><div class="po-rm-meta-k">'+escapeHtml(t(data.page.meta_status_k))+'</div><div class="po-rm-meta-v">'+protectCanonicalTerms(t(data.page.meta_status_v))+'</div></div>'+
      '<div class="po-rm-meta-card"><div class="po-rm-meta-k">'+escapeHtml(t(data.page.meta_internal_k))+'</div><div class="po-rm-meta-v">'+protectCanonicalTerms(t(data.page.meta_internal_v))+'</div></div>'+
      '<div class="po-rm-meta-card"><div class="po-rm-meta-k">'+escapeHtml(t(data.page.meta_field_k))+'</div><div class="po-rm-meta-v">'+protectCanonicalTerms(t(data.page.meta_field_v))+'</div></div>'+
      '</div></div></div>'+
      '<div class="po-rm-body"><div class="po-rm-wrap"><div class="po-rm-topbar">'+
      '<div class="po-rm-hint">'+protectCanonicalTerms(t(data.page.researchHint))+'</div>'+
      '<div class="po-rm-badge"><span class="po-rm-badge-dot"></span>'+escapeHtml(t(data.page.researchOn))+'</div>'+
      '</div><div class="po-rm-tabs" role="tablist" aria-label="'+escapeHtml(t(data.page.tabs_label))+'">'+
      tabs.map(function(tab,i){ return renderTabButton(tab, i===0); }).join('')+
      '</div><div class="po-rm-panels">'+tabs.map(function(tab,i){ return renderPanel(tab, i===0, i); }).join('')+'</div></div></div></section>';
  }

  function bindTabs(){
    var tabs = mount.querySelectorAll('[data-po-tab]');
    var panels = mount.querySelectorAll('[data-po-panel]');
    tabs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-po-tab');
        tabs.forEach(function(b){ var active=b===btn; b.classList.toggle('is-active',active); b.setAttribute('aria-selected', active?'true':'false'); });
        panels.forEach(function(panel){ panel.classList.toggle('is-active', panel.getAttribute('data-po-panel')===id); });
      });
    });
  }

  function rerender(){
    if(!allData) return;
    var data = allData[lang] || allData.fr;
    mount.innerHTML = renderApp(data);
    bindTabs();
  }

  function bindLangs(){
    var buttons = shell.querySelectorAll('[data-po-lang]');
    buttons.forEach(function(btn){
      btn.addEventListener('click', function(){
        var next = btn.getAttribute('data-po-lang');
        if(!next || next===lang) return;
        setLang(next); syncLangButtons(); rerender();
      });
    });
  }

  function injectStyles(){
    if(document.getElementById('po-katuvys-research-style')) return;
    var style = document.createElement('style');
    style.id = 'po-katuvys-research-style';
    style.textContent = `
      .po-katuvys-research-shell,.po-katuvys-research-shell *{box-sizing:border-box}
      .po-katuvys-research-shell{background:#f7f6f2;color:#1f1b16}
      .po-pagehead{padding:18px 0 12px;background:#f3efe6}
      .po-pagehead__nav,.po-pagehead__langs,.po-rm-wrap{width:min(1120px,calc(100% - 40px));margin:0 auto}
      .po-pagehead__nav{display:flex;flex-wrap:wrap;gap:12px;justify-content:center;align-items:center}
      .po-chip{display:inline-flex;align-items:center;justify-content:center;padding:10px 16px;border:1px solid rgba(0,0,0,.10);border-radius:999px;background:rgba(255,255,255,.45);text-decoration:none;color:#2b2824;font:600 11px/1 Arial,sans-serif;letter-spacing:.18em;text-transform:uppercase}
      .po-chip[aria-current="page"]{background:rgba(255,255,255,.68);border-color:rgba(0,0,0,.16)}
      .po-pagehead__langs{display:flex;justify-content:center;gap:10px;margin-top:10px}
      .po-lang{width:46px;height:36px;border-radius:999px;cursor:pointer;border:1px solid rgba(0,0,0,.16);background:#fff;font:700 11px/1 Arial,sans-serif;letter-spacing:.12em}
      .po-lang[aria-pressed="true"]{border-color:#a57b1b;box-shadow:0 0 0 2px rgba(165,123,27,.14) inset}
      .po-rm-hero{padding:54px 0 40px;background:linear-gradient(180deg,#efece6 0%,#e7edf0 100%)}
      .po-rm-eyebrow{font:600 12px/1.2 Arial,sans-serif;letter-spacing:.18em;text-transform:uppercase;color:#736c61;margin:0 0 10px}
      .po-rm-h1{margin:0 0 10px;font:500 56px/1.02 Georgia,serif}
      .po-rm-rule{width:34px;height:2px;background:#a57b1b;margin:10px 0 18px}
      .po-rm-lede{max-width:920px;margin:0;font:400 15px/1.7 Arial,sans-serif;color:#645e55}
      .po-rm-meta{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px;margin-top:24px}
      .po-rm-meta-card{background:#fbfaf7;border:1px solid #ddd8cf;padding:14px}
      .po-rm-meta-k{font:600 10px/1 Arial,sans-serif;letter-spacing:.20em;text-transform:uppercase;color:#8d857a;margin-bottom:8px}
      .po-rm-meta-v{font:500 18px/1.2 Georgia,serif}
      .po-rm-body{padding:22px 0 56px}
      .po-rm-topbar{display:flex;justify-content:space-between;gap:16px;align-items:flex-end;margin-bottom:18px}
      .po-rm-hint{max-width:600px;font:400 12px/1.55 Arial,sans-serif;color:#6d665c}
      .po-rm-badge{display:inline-flex;align-items:center;gap:8px;padding:11px 14px;border:1px solid #d8d2c8;background:#fbfaf7;font:600 11px/1 Arial,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#6a645a}
      .po-rm-badge-dot{width:9px;height:9px;border-radius:50%;background:#a57b1b;display:inline-block}
      .po-rm-tabs{display:flex;flex-wrap:wrap;gap:10px;margin:8px 0 18px}
      .po-rm-tab{border:1px solid #d5d0c6;background:transparent;color:#776f63;cursor:pointer;padding:9px 14px;font:400 12px/1 Arial,sans-serif}
      .po-rm-tab.is-active{background:#a57b1b;border-color:#a57b1b;color:#fff}
      .po-rm-tabpanel{display:none}
      .po-rm-tabpanel.is-active{display:block}
      .po-rm-sectionhead{border:1px solid #ddd8cf;background:#fbfaf7;padding:18px;margin-bottom:16px}
      .po-rm-section-kicker{font:600 10px/1 Arial,sans-serif;letter-spacing:.22em;text-transform:uppercase;color:#8b8579;margin-bottom:10px}
      .po-rm-section-title{margin:0 0 10px;font:500 34px/1.06 Georgia,serif}
      .po-rm-section-lede{margin:0;font:400 14px/1.7 Arial,sans-serif;color:#5e584f}
      .po-rm-item{border:1px solid #ddd8cf;background:#fbfaf7;margin:0 0 14px}
      .po-rm-summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;gap:16px;padding:18px}
      .po-rm-summary::-webkit-details-marker{display:none}
      .po-rm-summary-left{display:flex;gap:12px;flex-wrap:wrap;align-items:baseline}
      .po-rm-kicker{font:600 10px/1 Arial,sans-serif;letter-spacing:.22em;text-transform:uppercase;color:#8b8579}
      .po-rm-title{font:500 30px/1.06 Georgia,serif}
      .po-rm-kind{font:600 10px/1 Arial,sans-serif;letter-spacing:.22em;text-transform:uppercase;color:#a57b1b}
      .po-rm-chevron{width:16px;height:16px;flex:0 0 auto;margin-right:2px;border-right:1.8px solid #8b8579;border-bottom:1.8px solid #8b8579;transform:rotate(-45deg)}
      .po-rm-item[open] .po-rm-chevron{transform:rotate(45deg)}
      .po-rm-panel{padding:18px;border-top:1px solid #e3ded5}
      .po-rm-grid{display:grid;grid-template-columns:1.2fr .9fr;gap:22px}
      .po-rm-copy p,.po-rm-block p,.po-rm-note p{margin:0 0 12px;font:400 14px/1.72 Arial,sans-serif;color:#2f2a24}
      .po-rm-stats{display:grid;gap:12px}
      .po-rm-stat{border:1px solid #e2ddd4;background:#f7f4ee;padding:12px 13px}
      .po-rm-stat-k{font:600 10px/1 Arial,sans-serif;letter-spacing:.20em;text-transform:uppercase;color:#8d877a;margin-bottom:8px}
      .po-rm-stat-v{font:500 17px/1.2 Georgia,serif}
      .po-rm-blocks,.po-rm-notes,.po-rm-cards{display:grid;gap:12px;margin-top:16px}
      .po-rm-notes{grid-template-columns:repeat(3,minmax(0,1fr))}
      .po-rm-block,.po-rm-note,.po-rm-card{border:1px solid #e2ddd4;background:#f8f6f1;padding:14px}
      .po-rm-block-title,.po-rm-note-title,.po-rm-card-title{font:600 10px/1 Arial,sans-serif;letter-spacing:.20em;text-transform:uppercase;color:#8b8579;margin-bottom:10px}
      .po-rm-table{width:100%;border-collapse:collapse}
      .po-rm-table th,.po-rm-table td{padding:8px 10px;border-top:1px solid #e2ddd4;text-align:left;vertical-align:top;font:400 13px/1.55 Arial,sans-serif}
      .po-rm-table th{width:34%;font-weight:700}
      .po-rm-bullets{margin:0;padding-left:18px}
      .po-rm-bullets li{margin:0 0 8px;font:400 13px/1.6 Arial,sans-serif}
      @media (max-width:980px){.po-rm-meta{grid-template-columns:repeat(2,minmax(0,1fr))}.po-rm-grid{grid-template-columns:1fr}.po-rm-notes{grid-template-columns:1fr}}
      @media (max-width:640px){.po-pagehead__nav,.po-pagehead__langs,.po-rm-wrap{width:calc(100% - 24px)}.po-rm-h1{font-size:40px}.po-rm-meta{grid-template-columns:1fr}.po-rm-topbar{flex-direction:column;align-items:flex-start}}
    `;
    document.head.appendChild(style);
  }

  function fetchData(){
    var url = shell.getAttribute('data-po-json-url');
    return fetch(url,{credentials:'same-origin'}).then(function(res){
      if(!res.ok) throw new Error('JSON fetch failed');
      return res.json();
    });
  }

  function init(){
    shell = document.getElementById(SHELL_ID);
    mount = document.querySelector(MOUNT_SELECTOR);
    if(!shell || !mount) return;

    injectStyles();

    if(!isResearchMode()){ hideShell(); return; }

    setLang(getSavedLang());
    syncLangButtons();
    showShell();
    closePreviousBlock();
    bindLangs();

    fetchData().then(function(json){ allData=json; rerender(); })
      .catch(function(){
        mount.innerHTML = '<div style="padding:20px;border:1px solid #ddd;background:#fff;font-family:Arial,sans-serif;">Erreur de chargement du JSON du mode chercheur.</div>';
      });
  }

  ready(init);
})();
